// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1KgX9","alertIcon":"ConfirmModal_alertIcon__1zF5N"};